// @flow

import { type ApiParamsType, httpCall } from '../../common/http'

function apiCall (path: string, params: ApiParamsType): Promise<any> {
  return httpCall({
    ...params,
    url: `${process.env.CHATBUBBLE_API}/${path}`,
    retries: 3
  })
}

export const getSubscriberSocketInfo = (subscriberId: string, customerId: string, referrer: string): any => {
  return apiCall(`users/${subscriberId}?customerId=${customerId}&referrer=${referrer}`, { ...null })
}
